import { InjectionToken, ValueProvider } from '@angular/core';

import { AppConfigInterface } from './models/index';

export const APP_CONFIG: InjectionToken<AppConfigInterface> = new InjectionToken<AppConfigInterface>('cz-app-config');

export function appConfigProvider(value: AppConfigInterface): ValueProvider {
  return { provide: APP_CONFIG, useValue: value };
}
